<template>
  <b-modal
      id="modal-historico-descricoes"
      ref="modal"
      size="xl"
      title="Descrições Favoritas"
      title-class="font-18"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @hidden="$emit('hidden')">
    <div class="modal-body">
      <loader :loading="loading">
        <fieldset class="row border div-group">
          <legend class="div-group">Descrições favoritas</legend>
          <div class="col-md-12">
            <div v-if="lista && lista.length < 1"
                 class="alert alert-warning text-dark" role="alert">
              <h5>Sem descrições favoritas</h5>
              <p>Clique em <b>Adicionar descrição aos favoritos</b> abaixo do campo <b>Descrição dos serviço</b> para
                adicionar descrição aos favoritos.</p>
            </div>
            <div class="table-responsive">
              <table class="table table-centered mb-0">
                <tbody>
                <tr v-for="f in lista" :key="f.dsf_codigo">
                  <td class="border-0 border-white">
                    <a href="javascript:void(0);" @click="selecionar(f.dsf_descricao)">Selecionar</a>
                  </td>
                  <td class="border-0 border-white">
                    {{ f.dsf_descricao }}
                  </td>
                  <td class="border-0 border-white">
                    <a href="javascript:void(0);" @click="$emit('remover', f.dsf_codigo)" class="text-danger">Remover</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </fieldset>
      </loader>
    </div>
    <template #modal-footer>
      <b-button @click="fechar" variant="outline-dark">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Loader from "@/components/widgets/loader";

export default {
  name: "ModalDescricoesFavoritas",
  components: { Loader },
  props: {
    lista: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    fechar() {
      this.$refs.modal.hide();
    },
    selecionar(descricao) {
      this.$emit('selecionar', descricao);
      this.fechar();
    },
  },
};
</script>
